import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { ListComponent } from './view/list/list.component';
import { OverviewComponent } from './view/overview/overview.component';
import { DetailComponent } from './view/detail/detail.component';
import { LoginComponent } from './view/login/login.component';
import { AutomobiliaComponent } from './view/automobilia/automobilia.component';
import { ContactComponent } from './view/contact/contact.component';
import { ImprintComponent } from './view/imprint/imprint.component';
import { AuthGuard } from './services/auth-guard.service';
import { DealerManagementComponent } from './view/dealer-management/dealer-management.component';
import { Role } from './models/role.model';
import { AutomobiliaManagementComponent } from './view/automobilia-management/automobilia-management.component';
import { ForgotPasswordComponent } from './view/forgot-password/forgot-password.component';
import { ResetPasswordComponent } from './view/reset-password/reset-password.component';
import {CarsWantedComponent} from './view/cars-wanted/cars-wanted.component';
import {CarsWantedManagementComponent} from './view/cars-wanted-management/cars-wanted-management.component';
import {TermsOfServiceComponent} from './view/terms-of-service/terms-of-service.component';
import {PrivacyComponent} from './view/privacy/privacy.component';

const routes: Routes = [
  {
    path: '',
    redirectTo: 'login',
    pathMatch: 'full'
  },
  {
    path: 'login',
    component: LoginComponent
  },
  {
    path: 'forgot-password',
    component: ForgotPasswordComponent
  },
  {
    path: 'reset-password/:token/:lang',
    component: ResetPasswordComponent
  },
  {
    path: 'activate-password/:token/:lang',
    component: ResetPasswordComponent
  },
  {
    path: 'dealer-management',
    component: DealerManagementComponent,
    canActivate: [AuthGuard],
    data: { role: [Role.Admin] }
  },
  {
    path: 'automobilia-management',
    component: AutomobiliaManagementComponent,
    canActivate: [AuthGuard],
    data: { role: [Role.Admin] }
  },
  {
    path: 'cars-wanted-management',
    component: CarsWantedManagementComponent,
    canActivate: [AuthGuard],
    data: { role: [Role.Admin] }
  },
  {
    path: 'overview',
    component: OverviewComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'list',
    component: ListComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'detail/:id',
    component: DetailComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'automobilia',
    component: AutomobiliaComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'cars-wanted',
    component: CarsWantedComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'contact/:type/:id',
    component: ContactComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'contact',
    component: ContactComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'imprint',
    component: ImprintComponent
  },
  {
    path: 'terms-of-service',
    component: TermsOfServiceComponent
  },
  {
    path: 'privacy',
    component: PrivacyComponent
  },
  { path: '**',
    redirectTo: 'login',
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {
    scrollPositionRestoration: 'enabled',
    anchorScrolling: 'enabled',
  })],
  exports: [RouterModule],
  providers: []
})
export class AppRoutingModule { }
